import { render, staticRenderFns } from "./role-create.vue?vue&type=template&id=e7a59f8e&"
import script from "./role-create.vue?vue&type=script&lang=js&"
export * from "./role-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports